import {FETCH_SUPPORT_USERS, GET_SUPPORT_USERS} from './types';
import axios from 'axios';
import {urlConfig} from "../config"
import UserService from "../Services/UserService";

const baseAuthUrl = `${urlConfig.bffUrl}`;

function supportUsersResponseHandler(querySnapshot) {
    return new Promise((resolve, reject) => {
        let supportUsers = querySnapshot.data;
        console.log("String",querySnapshot);
        // querySnapshot.forEach(function(doc) {
        //     let userData = doc.data();
        //     supportUsers.push(userData.useremail);
        // });
        resolve(supportUsers);
    })

}

export function fetchSupportUsers(data) {
    return (dispatch) => UserService.getSupportUsers(data)
        .then((querySnapshot) => {
            //return supportUsersResponseHandler(querySnapshot)
            return querySnapshot.data
        }, error => {
        })
        .then(
            response => dispatch({type: FETCH_SUPPORT_USERS, payload: response}),
            error => dispatch({type: FETCH_SUPPORT_USERS, payload: error})
        )
}

export function getSupportUsers() {
    return (dispatch) => {
        dispatch({
            type: GET_SUPPORT_USERS,
        })
    }
}
